module.exports = __webpack_public_path__ + "img/prod-3.6f733ea0.png";